export enum SyncStatus {
  NOT_STARTED = 'not_started',
  RUNNING = 'running',
  ERROR = 'error',
  COMPLETED = 'completed',
}
